<div class="flex-container">
  <div class="flex-container__toggle">
    <mat-slide-toggle color="primary"
      (change)="toggleMode($event.checked)">
      3D
    </mat-slide-toggle>
  </div>
  <div class="flex-container__map">
    <div id="map" appOlMap></div>
    <p id="status"></p>
  </div>
</div>


